import React from "react"
import { useLocation } from "react-router-dom"

import ChargingLoader from "../components/feedback/ChargingLoader"
import Loading from "../components/feedback/Loading"
import { brandingStyle } from "../views/public/branding/brandingStyle"
import { readStoredBranding } from "../views/public/branding/brandingStorage"
import { isPublicPaymentPath } from "./routeLoading"

/**
 * Loading screen of the route chunks. The public payment pages get the charging circle, in the operator colors when
 * the tab already knows them, the rest of the app keeps the EVPOS wordmark.
 *
 * @returns {JSX.Element} Loading screen for the current route
 * */
export default function RouteLoadingScreen() {
	const { pathname } = useLocation()

	if (!isPublicPaymentPath(pathname)) return <Loading />

	return (
		<div
			style={{
				...brandingStyle(readStoredBranding()),
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				background: "var(--m-background-color, #f6f7fb)",
			}}
		>
			<ChargingLoader />
		</div>
	)
}
